import React from 'react';
import pic from '../../images/mahikacafe2.jpg';
import mahikastore from '../../images/mahikastore.jpg';
import mahikathings from '../../images/mahikathings.jpg';
import AboutUsPageCSS from './AboutUsPage.module.css';

export default function AboutUsPage() {
  return (
    <>
      <div className="about">
        <img src={pic} className={AboutUsPageCSS.pic} alt="mahika" />

        <div className={AboutUsPageCSS["about-content"]}>
          <div className={AboutUsPageCSS["content-left"]}>
            <p>At Mahika Cafe, a cup of coffee is a sensory experience. Our ambiance transports you to a world of warmth, inspiration, and relaxation.</p>
            <img src={mahikastore} className={AboutUsPageCSS.mahikastore} alt="mahika" />
          </div>

          <div className={AboutUsPageCSS["content-right"]}>
            <img src={mahikathings} className={AboutUsPageCSS.mahikathings} alt="mahikaa" />
            <p>At Mahika Cafe, every cup tells a story, creating warmth and connection from the first aroma to the last sip—discover our delightful offerings.</p>
          </div>
        </div>
      </div>
    </>
  );
}
